import React from 'react';

import Features from '@dashboard/enums/features';

import usePage from '@dashboard/hooks/usePage';

import CanUseFeature from '@dashboard/components/CanUseFeature';
import Link from '@dashboard/components/Link';

import PageEditView from '../components/PageEditView';

import ColorsForm from './PageSettings/components/ColorsForm';
import CustomCSSForm from './PageSettings/components/CustomCSSForm';
import CustomLabelsForm from './PageSettings/components/CustomLabelsForm';
import LayoutForm from './PageSettings/components/LayoutForm';
import LocaleForm from './PageSettings/components/LocaleForm';
import ShowHideElementsForm from './PageSettings/components/ShowHideElementsForm';

const PageDesign = () => {
  const { page } = usePage();

  return (
    <PageEditView
      tabs={[
        {
          path: '/layout',
          label: 'Layout',
          component: <LayoutForm />,
        },
        {
          path: '/colors',
          label: 'Colors',
          component: <ColorsForm />,
        },
        {
          path: '/elements',
          label: 'Elements',
          component: <ShowHideElementsForm />,
        },
        {
          path: '/custom-css',
          label: 'Custom CSS',
          component: (
            <CanUseFeature feature={Features.CUSTOM_CSS}>
              <CustomCSSForm />
            </CanUseFeature>
          ),
          description: (
            <>
              Customize the look and feel with CSS. Please note, only predefined classes should be
              used.{' '}
              <Link to="/help/articles/adding-custom-css-to-your-checkout" target="_blank">
                Learn more
              </Link>
              .
            </>
          ),
        },
        {
          path: '/custom-labels',
          label: 'Custom labels',
          component: <CustomLabelsForm />,
          description: <>Customize or translate labels & messages.</>,
        },
        ...(page.type === 'checkout' || page.type === 'event'
          ? [
              {
                path: '/currency-formatting',
                label: 'Currency formatting',
                component: <LocaleForm />,
                description: "Select the currency format of the country you're selling in.",
              },
            ]
          : []),
      ]}
    />
  );
};

export default PageDesign;
